import { API_GET_ALL_PROVIDER, API_GET_ALL_PROVIDER_SUCCESS, API_GET_ALL_PROVIDER_FAIL } from "../actions/provider";
import { createReducer } from "@reduxjs/toolkit";
import { errorHandler, ErrorAction } from "utils/error";

const initialState = {
	loading: false,
	list: [],
};

const providers = createReducer(initialState, {
	/** GET ALL **/
	[API_GET_ALL_PROVIDER]: (state, action) => {
		state.loading = true;
	},
	[API_GET_ALL_PROVIDER_FAIL]: (state, action) => {
		errorHandler("Réseau", ErrorAction.READ, action.error);
		state.loading = false;
		state.list = [];
	},
	[API_GET_ALL_PROVIDER_SUCCESS]: (state, action) => {
		state.loading = false;
		state.list = action.payload.data;
	},
});

export default providers;
